<div class="assessment">
  <div class="assessment-content">
    <cw-dialog #dialog [title]='dialogTitle' [showCloseButton]='showCloseButton' [showLogo]='false' (eventHandler)="buttonAction('cancel')">
      <div class="custom-header-action">
        <ng-container></ng-container>
      </div>
      <div class="form-header" >{{dialogMessage}}</div>
      <form class="form-field-list" [formGroup]="assessmentTypeForm">
        <mat-form-field>
          <input type="text" matInput placeholder="Company Name" formControlName="accountNameDropdown" 
          [matAutocomplete]="dropDown.auto" required [formControl]="stateCtrl">
          <cw-account-dropdown #dropDown
            [partnerAccount]="account"    
            [disableInUseAccounts]="true"            
            [searchControl]="assessmentTypeForm.controls.accountNameDropdown">
          </cw-account-dropdown>
          <mat-error *ngIf="assessmentTypeForm.controls.accountNameDropdown?.touched && !assessmentTypeForm.controls.accountNameDropdown?.value">Please select a value from the dropdown</mat-error>
        </mat-form-field>

        <mat-form-field  [floatLabel]="isLoading">
          <input type="text" matInput placeholder="Select Assessment" formControlName="assessment" [matAutocomplete]="assessments.auto" [readonly]="!assessmentTypeForm.controls.accountNameDropdown?.value" required>
          <cw-assessments-dropdown #assessments [searchControl]="assessmentTypeForm.controls.assessment" 
            [planId]="planId" [isInTrial]="isInTrial" [includeTypeList]="['CERTIFICATION']">
          </cw-assessments-dropdown>
          <mat-error *ngIf="assessmentTypeForm.controls.assessment?.touched && !assessmentTypeForm.controls.assessment?.value && !assessmentTypeForm.controls.assessment?.hasError('isPlanExist') && !assessmentTypeForm.controls.assessment?.hasError('isCertificationEnabled')">Please select a value from the dropdown</mat-error>
          <mat-error *ngIf="assessmentTypeForm.controls.assessment?.hasError('invalid')">Certification exists and is In Progress</mat-error>
          <mat-error *ngIf="assessmentTypeForm.controls.assessment?.hasError('isPlanExist')">Selected accounts plan does not have a certification associated with it</mat-error>
          <mat-error *ngIf="assessmentTypeForm.controls.assessment?.hasError('isCertificationEnabled')">Selected accounts does not have a certification enabled</mat-error>

          <mat-label *ngIf="isLoading">
            <div class="select-placeholder-container">
              <span>Loading...</span>
            </div>
          </mat-label>
        </mat-form-field>
      </form>
      <button *ngIf="cancelButton" mat-button color="primary" (click)="buttonAction('cancel')">{{cancelButtonText}}</button>      
      <button [disabled]="assessmentTypeForm.invalid || isLoading" mat-raised-button type="button" color="primary" (click)="addAssessment()">{{buttonText}}</button>
    </cw-dialog>
  </div>
</div>